import { EmptyObject } from '@client/new/helpers/types';

const toLine = <T extends EmptyObject>(keys: Array<keyof T>, v: T) =>
  keys
    .map((k) => `${v[k]}`.replace(/"/g, '""'))
    .map((r) => `"${r}"`)
    .join(',');

export const generateCSV = <T extends EmptyObject>(rows: T[]) => {
  if (!rows || !rows.length) return '';
  const hs = Object.keys(rows[0]);
  return [hs.join(','), ...rows.map((l) => toLine(hs, l))].join('\n');
};

const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.visibility = 'hidden';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const getCSV = <T extends EmptyObject>(data: T[], name: string) =>
  downloadCSV(generateCSV(data), name);
